import { CircularProgress, Dialog, DialogContent } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { customerDetail } from '../../redux/Customer/action';
import { invoiceDetails } from '../../redux/Invoice/action';
import { formatNumberDecimaWithoutRoundoff } from '../../utility/helpers/commonFunction';
import InvoiceDraft from './Drafts/InvoiceDraft';
import InvoiceFinalized from './Finalized/InvoiceFinalized';
import InvoiceSend from './Send/InvoiceSend';

const InvoiceDetail = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [invoiceData, setInvoiceData] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const [customerData, setCustomerData] = React.useState('');

    const fetchInvoceDetailData = useCallback(async () => {
        setShowLoader(true);
        let data = await dispatch(invoiceDetails(`${id}`));

        if (data) {
            setInvoiceData({
                ...data,
                Total: formatNumberDecimaWithoutRoundoff(data.Total),
                totalAmountPending: formatNumberDecimaWithoutRoundoff(data.totalAmountPending),
            });
            if (data?.status === 'sent' && !data?.isEmailSent) {
                fetchCustomerDetail(data);
            }
        }
        setShowLoader(false);
    }, [dispatch, id]);

    useEffect(() => {
        fetchInvoceDetailData();
    }, [fetchInvoceDetailData]);

    const fetchCustomerDetail = async (data) => {
        setShowLoader(true);

        await dispatch(customerDetail(data?.customer?._id));
        setShowLoader(false);
    };

    // Fetch invoice details and navigate based on status
    // useEffect(() => {
    //     if (!invoiceData || !id) return;
    //     const { status, isEmailSent } = invoiceData;
    //     const locationPath = location.pathname;
    //     let targetPath = '';

    //     if (status === 'draft') {
    //         targetPath = `/invoice/draft/${id}`;
    //     } else if (status === 'sent' && !isEmailSent) {
    //         targetPath = `/invoice/finalized/${id}`;
    //     } else if (status === 'sent' && isEmailSent) {
    //         targetPath = `/invoice/sent/${id}`;
    //     }

    //     if (targetPath && locationPath !== targetPath) {
    //         navigate(targetPath);
    //     }
    // }, [invoiceData, id, navigate, location.pathname]);

    switch (true) {
        case invoiceData?.status === 'draft':
            return (
                <InvoiceDraft invoiceId={id} invoiceData={invoiceData} setShowLoader={setShowLoader} showLoader={showLoader} fetchApi={fetchInvoceDetailData} />
            );
        case invoiceData?.status === 'sent' && invoiceData?.isEmailSent:
            return (
                <InvoiceSend invoiceId={id} invoiceData={invoiceData} setShowLoader={setShowLoader} showLoader={showLoader} fetchApi={fetchInvoceDetailData} />
            );
        case invoiceData?.status === 'sent' && !invoiceData?.isEmailSent:
            return (
                <InvoiceFinalized
                    invoiceId={id}
                    invoiceData={invoiceData}
                    customerData={customerData}
                    setCustomerData={setCustomerData}
                    setShowLoader={setShowLoader}
                    fetchApi={fetchInvoceDetailData}
                    showLoader={showLoader}
                />
            );
        case showLoader === true:
            return (
                <Dialog open={showLoader}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
            );

        default:
            return null;
    }
};

export default InvoiceDetail;
